import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { LoadingSpinner } from '../components/LoadingSpinner'

export function AuthCallback() {
  const navigate = useNavigate()
  const [isProcessing, setIsProcessing] = useState(true)

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Wait for Supabase to process the OAuth callback
        const { data: { session }, error } = await supabase.auth.getSession()
        
        if (error) {
          console.error('Auth callback error:', error)
          navigate('/login', { replace: true })
          return
        }

        if (session) {
          // Session is ready, get redirect path
          const redirectPath = sessionStorage.getItem('redirectAfterAuth')
          sessionStorage.removeItem('redirectAfterAuth')
          
          // Now it's safe to redirect
          navigate(redirectPath || '/', { replace: true })
        } else {
          // No session, back to login
          navigate('/login', { replace: true })
        }
      } catch (error) {
        console.error('Auth callback error:', error)
        navigate('/login', { replace: true })
      } finally {
        setIsProcessing(false)
      }
    }

    // Small delay to let Supabase URL params get processed
    const timer = setTimeout(handleAuthCallback, 100)
    
    return () => clearTimeout(timer)
  }, [navigate])

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <LoadingSpinner />
        <p className="mt-4 text-gray-400">
          {isProcessing ? 'Anmeldung wird verarbeitet...' : 'Weiterleitung...'}
        </p>
      </div>
    </div>
  )
}